
import React, {Component} from 'react';


class SmsChannelFineTuning extends Component {
    constructor(props){
        super(props);
        this.state = {

        }
    }


    async componentDidMount() {
    }

    async componentDidUpdate(){
    }

    render() {

        return(

            <div className="channel-container" ref={el => (this.container = el)}>
                <div className="channel-heading-container">
                    <h3>SMS</h3>
                </div>
                <h3>Fine tuning</h3>
            </div>
        )

    }
}


export default SmsChannelFineTuning;